import { documentDeepLink } from "../../../lib/documentDeepLink.ts";
import type { QuinnDocumentSource } from "../types";

export function documentSourceHref(document: QuinnDocumentSource): string | null {
    if (!document.document_id || !document.business_id) {
        return null;
    }
    return documentDeepLink(document.document_id, document.business_id);
}

export function documentSourceCounterparty(document: QuinnDocumentSource): string | null {
    return document.counterparty || document.scanned_fields?.seller_name || null;
}

export function documentSourceDate(document: QuinnDocumentSource): string | null {
    return (
        document.document_date ||
        document.scanned_fields?.normalized_datetime ||
        document.scanned_fields?.date ||
        null
    );
}
